<bp-svg-icon bpTooltip="Upgrade to unlock!" name="star" class="bp-icon-sm"></bp-svg-icon>
